import { render } from "./Windows.vue?vue&type=template&id=b99e85ae&scoped=true"
import script from "./Windows.vue?vue&type=script&lang=js"
export * from "./Windows.vue?vue&type=script&lang=js"

import "./Windows.vue?vue&type=style&index=0&id=b99e85ae&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Azizi\\Documents\\Personal\\houselayout\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b99e85ae"]])

export default __exports__